// extracted by mini-css-extract-plugin
module.exports = {"addPost":"index_addPost_3t0IM","label":"index_label_33C5-","submit":"index_submit_2U1C6","editor":"index_editor_1QCze"};